import axios from "axios"
import ConfirmingAction from "common/ConfirmingAction"
import React, { useState , useEffect} from "react"
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap"
function IdenticalModal({ isOpen, toggle, selectedItem }) {
  const [PersonalCongirm, setPersonalCongirm] = useState(false)

  const [identical,setIdentical]=useState("")

  const handlesubmit = e => {
    e.preventDefault()
    setPersonalCongirm(true)
  }


  const confirmFunc = (identical) => {
    let data = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      PStageID: selectedItem.PStageID,
      IsIdentical: identical,
    }
    axios
      .post(process.env.REACT_APP_API_URL+"api/balady/IdenticalBalady.php", data)
      .then(response => {
        toggle()
      })
      .catch(error => {})
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Data Identicality Check</ModalHeader>
      <form
        onSubmit={e => {
          handlesubmit(e)
        }}
      >
        <ModalBody style={{ marginLeft: "50px" }}>
        <div className="d-flex mb-4 ">
            <Input type="checkbox" onChange={(e)=>{e.target.checked?setPersonalCongirm(true):setPersonalCongirm(false)}} name="text" id="exampleText" />
            <Label className="ms-2" for="exampleText">I understand that this action is irreversible and cannot be undon</Label>
          </div>
          <h5>Is Data Identical?</h5>
          <div className="d-flex col-8 ms-5 mt-4 justify-content-between">     
            <div className="mb-3 ">
              <Button type="submit" disabled={!PersonalCongirm} className="d-flex align-items-center bg-danger" onClick={(e)=>confirmFunc("2")}>
                
               Not Identical
              </Button>
            </div>
            <div className="mb-3 ms-5">
              <Button type="submit" disabled={!PersonalCongirm} className="d-flex align-items-center bg-success" onClick={(e)=>confirmFunc("1")}>
                 Identical
              </Button>
            </div>
          </div>

        </ModalBody>

      </form>

    </Modal>
  )
}

export default IdenticalModal
